<div id="ebb-stepper-scroller-top"></div>
<mat-progress-bar *ngIf="loading" mode="indeterminate" ></mat-progress-bar>
<div [class]="loading ? 'row loading': 'row not-loading'">
  <div class="col-md-12">
    <mat-horizontal-stepper *ngIf="programCycle" linear ebbStepperScroller>
      <mat-step [stepControl]="applicationInput">
        <ng-template matStepLabel>Qualify this property</ng-template>
        <div [hidden]="stepSection !== 1">
          <ebb-start
            [program]="programCycle"
            [dwelling$]="dwelling$"
            [policies]="policies"
            [dwellingNextInProcessComplete]="dwellingNextInProcessComplete"
            (isFormInvalid)="isDwellingFormInvalidChange($event)"
            (nextSection)="changeStepSection($event)"
            (emitDwelling)="handleDwelling($event)">
          </ebb-start>
        </div>
        <div *ngIf="stepSection === 2">
          <ebb-house
            [dwelling$]="dwelling$"
            [questionnaire$]="questionnaire$"
            (isFormInvalid)="isQuestionnaireFormInvalidChange($event)"
            (leaveForm)="changeStepSection($event)"
            (qualify)="submitQualification($event)"
            [drawerOpen]="drawerOpen"
            [drawerContent]="drawerContent">
          </ebb-house>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Provide your contact details</ng-template>
        <ebb-contact-details
          [program]="programCycle"
          [programData]="programCycles"
          [userPolicy]="userPolicy"
          [contactData]="contactData"
          [dwelling$]="dwelling$"
          (contact)="submitContact($event)">
        </ebb-contact-details>
      </mat-step>
      <mat-step *ngIf="noB2cAccount">
        <ng-template matStepLabel>Activate your account</ng-template>
        <ebb-activate
          *ngIf="contact$"
          [contact$]="contact$"
          [contactData]="contactData"
          [message]="responseMessage"
          [tooManyAttempts]="tooManyAttempts"
          [activateNextInProcessComplete]="activateNextInProcessComplete"
          (accountInfo)="createAccount($event)"
          (loading)="loadingEvent($event)">
        </ebb-activate>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
<div class="row" *ngIf="error">
  <div style="color: red;" class="col-md-12">
    {{ error }}<br />
    Please contact Customer Service at (877) 232-4300 or at <a href="mailto:info@EarthquakeBraceBolt.com">info@EarthquakeBraceBolt.com</a>.
  </div>
</div>
